
export const LOST_OPTIONS_CLIENT_CHANGED_ID = 1
export const LOST_OPTIONS_CLIENT_DECIDED_ID = 2
export const LOST_OPTIONS_DUPLICATE_ID = 3
export const LOST_OPTIONS_OTHER_ID = 4

export const LOST_OPTIONS = [
  {
    id: LOST_OPTIONS_CLIENT_CHANGED_ID,
    text: 'client changed his mind and requested refund',
    disable: false
  },
  {
    id: LOST_OPTIONS_CLIENT_DECIDED_ID,
    text: 'client decided to use a different co and requested refund',
    disable: false
  },
  {
    id: LOST_OPTIONS_DUPLICATE_ID,
    text: 'duplicate project in the system',
    disable: false
  },
  {
    id: LOST_OPTIONS_OTHER_ID,
    text: 'other',
    disable: false
  }
]



// WEBPACK FOOTER //
// ./src/constants/lostOptions.js